import React from 'react';
import { Switch } from 'react-router-dom';
import { AdminRoute, ManagerRoute } from '../routes';
import UserList from './UserList';
import UserEdit from './UserEdit';

const UsersPage = ({ match: { path } }) => (
  <Switch>
    <ManagerRoute path={path} exact component={UserList} />
    <ManagerRoute path={`${path}/view/:id`} component={UserEdit} />
    <AdminRoute path={`${path}/edit/:id`} component={UserEdit} />
    <AdminRoute path={`${path}/create`} component={UserEdit} />
  </Switch>
);

export default UsersPage;



// WEBPACK FOOTER //
// ./src/components/users/UsersPage.js